<div class="pt-3 pl-md-4" *ngIf="!accountService.getMyAccount().can_manage_members">
  <h2>You do not have permission to manage customers.</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4 mb-6"
     *ngIf="accountService.getMyAccount().can_manage_members && serverError === null">

  <h2>
    {{ displayCheckInRangeCount ? 'Customer Check-In Counts in Date Range' : 'Customers'}}
    <span *ngIf="loadingCustomers" class="text-secondary">- Loading...</span>
    <span *ngIf="!loadingCustomers && customerList && propExists(customerList.count)">
      ({{ customerList.count.toLocaleString() }})
    </span>
  </h2>

  <div class="alert" role="alert"
       [class.alert-success]="history.state.feedback.status == 'success'"
       [class.alert-info]="history.state.feedback.status == 'info'"
       *ngIf="history && history.state && history.state.feedback">
    {{ history.state.feedback.text }}
  </div>

  <div class="alert customer-alert text-center" role="alert"
       [class.alert-success]="modalResult.status === CallbackResultStatus.success"
       *ngIf="modalResult !== null">
    {{ modalResult.text }}
  </div>

  <div class="alert alert-success customer-alert text-center" role="alert"
       *ngIf="createdCustomer !== null">
    An account was successfully created for {{ createdCustomer.first_name }} {{ createdCustomer.last_name }}.
    <br>
    <a [routerLink]="'/customers/' + createdCustomer.id.toString()"
       class="alert-link">
      Navigate to {{ createdCustomer.first_name }} {{ createdCustomer.last_name }}'s profile.
    </a>
  </div>

  <div class="row">
    <div class="col-xl-5 col-12 mb-3">
      <input type="text" class="form-control"
             placeholder="Search customers by email, name, barcode, and telephone"
             [(ngModel)]="filters.search"
             (ngModelChange)="handleCustomerFilterChange(true)">
    </div>
    <div class="col-xl-7 col-12 mb-3 clearfix">
      <ng-container *ngIf="!displayCheckInRangeCount">
        <button class="btn btn-outline-primary mr-2 mb-2" type="button"
                (click)="openEditFiltersModal()">
          Edit Filters
        </button>
        <div class="dropdown d-inline-block align-middle mb-2">
          <button class="btn btn-outline-primary dropdown-toggle"
                  type="button" id="moreDropdownButton"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            More
          </button>
          <div class="dropdown-menu" aria-labelledby="moreDropdownButton">
            <a class="dropdown-item"
               [class.disabled]="customCustomerFieldsLoading"
               [class.cursor-pointer]="!customCustomerFieldsLoading"
               [ngbTooltip]="customCustomerFieldsLoading ? 'Loading...' : null"
               (click)="!customCustomerFieldsLoading && openExportListModal()">Export List</a>
            <a class="dropdown-item"
               [class.disabled]="loadingSavedView || customCustomerFieldsLoading"
               [class.cursor-pointer]="!(loadingSavedView || customCustomerFieldsLoading)"
               [ngbTooltip]="customCustomerFieldsLoading ? 'Loading...' : null"
               (click)="!(loadingSavedView || customCustomerFieldsLoading) && openSelectReportColumnsModal()">Configure Columns</a>
            <a class="dropdown-item"
               [class.disabled]="loadingSavedView"
               [class.cursor-pointer]="!loadingSavedView"
               (click)="!loadingSavedView && openSavedViewsModal()">Saved Views</a>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="displayCheckInRangeCount">
        <button class="btn btn-outline-primary mr-2 mb-2" type="button"
                (click)="openEditFiltersModal()">
          Edit Filters
        </button>
        <button class="btn btn-outline-primary mr-2 mb-2" type="button"
                [disabled]="customCustomerFieldsLoading"
                [ngbTooltip]="customCustomerFieldsLoading ? 'Loading...' : null"
                (click)="openExportListModal()">
          Export List
        </button>
        <button class="btn btn-outline-primary mr-2 mb-2" type="button"
                [disabled]="loadingSavedView || customCustomerFieldsLoading"
                [class.disabled]="loadingSavedView || customCustomerFieldsLoading"
                [ngbTooltip]="customCustomerFieldsLoading ? 'Loading...' : null"
                (click)="openSelectReportColumnsModal()">
          Configure Columns
        </button>
        <button class="btn btn-outline-primary mb-2" type="button"
                [disabled]="loadingSavedView"
                [class.disabled]="loadingSavedView"
                (click)="openSavedViewsModal()">
          Saved Views
        </button>
      </ng-container>
      <ng-container *ngIf="!showBulkActions()">
        <div class="float-right mb-2">
          <button class="btn btn-success"
                  type="button" id="createNewCustomerButton"
                  *ngIf="!displayCheckInRangeCount"
                  (click)="openCreateCustomerModal()">
            Create New Customer
          </button>
        </div>
      </ng-container>
      <ng-container *ngIf="showBulkActions()">
        <div class="dropdown float-right mb-2">
          <button class="btn btn-outline-primary dropdown-toggle"
                  type="button" id="bulkDropdownButton"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                  [disabled]="tooManyCustomersForBulkAction()"
                  [class.disabled]="tooManyCustomersForBulkAction()"
                  [ngbTooltip]="tooManyCustomersForBulkAction() ? 'No more than ' + MAX_BULK_ACTION_SIZE.toLocaleString() + ' customers may be selected for bulk actions.' : ''"
                  placement="left">
            Bulk Actions
          </button>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="bulkDropdownButton">
            <a class="dropdown-item cursor-pointer"
               (click)="goToAddCreditOrVoucher()">Add Credit or Voucher</a>
            <a class="dropdown-item cursor-pointer"
               (click)="goToCreateBooking()">Book Onto Event</a>
            <a class="dropdown-item"
               [class.disabled]="loadingTags"
               [class.cursor-pointer]="!loadingTags"
               (click)="openBulkAddOrRemoveTagModal(true)">Add Tag</a>
            <a class="dropdown-item"
               [class.disabled]="loadingTags"
               [class.cursor-pointer]="!loadingTags"
               (click)="openBulkAddOrRemoveTagModal(false)">Remove Tag</a>
            <a class="dropdown-item cursor-pointer"
               (click)="openBulkAddOrRemoveChallengeModal(true)">Add To Challenge</a>
            <a class="dropdown-item cursor-pointer"
               (click)="openBulkAddOrRemoveChallengeModal(false)">Remove From Challenge</a>
            <a class="dropdown-item"
               [class.disabled]="loadingAssociations"
               [class.cursor-pointer]="!loadingAssociations"
               (click)="openBulkAddToAssociationModal()">Add To Association</a>
            <a class="dropdown-item cursor-pointer"
               (click)="openBulkAddGuestPassesModal()">Add Guest Passes</a>
            <a class="dropdown-item cursor-pointer"
               (click)="openBulkAddAlertModal()">Add Alert</a>
            <a class="dropdown-item cursor-pointer"
               *ngIf="usesSpecificAllthenticateProducts()"
               (click)="openBulkSendAllthenticateInviteModal()">Send Allthenticate Invite</a>
          </div>
        </div>
        <span class="float-right mr-2 mt-2">
          <b *ngIf="!allCustomersMatchingFiltersSelected">
            {{ selectedCustomerIds.length.toLocaleString() }} of {{ customerList.results.length.toLocaleString() }}
            customers selected
          </b>
          <b *ngIf="allCustomersMatchingFiltersSelected">
            {{ customerList.count.toLocaleString() }} customers selected
          </b>
        </span>
      </ng-container>
    </div>
  </div>

  <div *ngIf="getActiveFilters().length > 0" class="clearfix mb-2">
    <span *ngFor="let activeFilter of getActiveFilters()"
          class="filter-item mb-2 mr-2 cursor-pointer"
          (click)="openEditFiltersModal()">{{ activeFilter }}</span>
  </div>

  <app-saved-report-view-toolbar
    [savedView]="savedView"
    [loadingSavedView]="loadingSavedView"
    [savedViewEdited]="savedViewEdited"
    [personalDefaultViewId]="defaultReportViewId"
    [organizationDefaultViewId]="organizationDefaultReportViewId"
    (renameView)="openRenameSavedViewModal()"
    (deleteView)="deleteSavedView()"
    (saveChanges)="updateSavedView()"
    (saveAsNew)="openCreateSavedViewModal()">
  </app-saved-report-view-toolbar>

  <div class="row">
    <div class="col col-xl-3 col-lg-4 col-12" *ngIf="displayCheckInRangeCount">

      <div class="card mb-3" style="border-radius: 10px;">
        <div class="card-header font-weight-bold">
          Check-In Count Date Range
        </div>
        <div class="card-body">
          <div class="form-group">
            <label for="check_in_range_start">Start</label>
            <app-date-picker [id]="'check_in_range_start'"
                             [(content)]="filters.check_in_range_start"
                             (contentChange)="handleCustomerFilterChange()"></app-date-picker>
          </div>
          <div class="form-group">
            <label for="check_in_range_end">End</label>
            <app-date-picker [id]="'check_in_range_end'"
                             [(content)]="filters.check_in_range_end"
                             (contentChange)="handleCustomerFilterChange()"></app-date-picker>
          </div>
        </div>
      </div>

      <div class="card mb-3" style="border-radius: 10px;">
        <div class="card-header font-weight-bold">
          Check-In Count Filter
        </div>
        <div class="card-body">
          <div class="form-group">
            <label for="check_in_range_count_min">Min # Check-ins in Range</label>
            <input type="number" min="0" step="1"
                   class="form-control" id="check_in_range_count_min" name="check_in_range_count_min"
                   [(ngModel)]="filters.check_in_range_count_min"
                   (ngModelChange)="handleCustomerFilterChange()">
          </div>
          <div class="form-group">
            <label for="check_in_range_count_max">Max # Check-ins in Range</label>
            <input type="number" min="0" step="1"
                   class="form-control" id="check_in_range_count_max" name="check_in_range_count_max"
                   [(ngModel)]="filters.check_in_range_count_max"
                   (ngModelChange)="handleCustomerFilterChange()">
          </div>
        </div>
      </div>

    </div>
    <div class="col">
      <div class="alert alert-secondary" *ngIf="allCustomersSelected() && hasMultiplePages()">
        <ng-container *ngIf="!allCustomersMatchingFiltersSelected">
          <span class="text-nowrap d-inline-block mr-1">
            All <b>{{ customerList.results.length.toLocaleString() }}</b> customers on this page are selected.
          </span>
          <a href="#" class="text-nowrap d-inline-block"
             (click)="$event.preventDefault(); allCustomersMatchingFiltersSelected = true;">
            Select all <b>{{ customerList.count.toLocaleString() }}</b> customers matching the current filters
          </a>
        </ng-container>
        <ng-container *ngIf="allCustomersMatchingFiltersSelected">
          <span class="text-nowrap d-inline-block mr-1">
            All <b>{{ customerList.count.toLocaleString() }}</b> customers matching the current filters are selected.
          </span>
          <a href="#" class="text-nowrap d-inline-block"
             (click)="$event.preventDefault(); allCustomersMatchingFiltersSelected = false;">
            Select only the <b>{{ customerList.results.length.toLocaleString() }}</b> customers on this page
          </a>
        </ng-container>
      </div>

      <div class="rounded-table-wrapper table-responsive-lg">
        <table class="table table-hover">

          <thead>
          <tr>
            <th *ngIf="customerResultsPresent()" scope="col" class="checkbox-cell"
                (click)="toggleCustomerSelectAll()">
              <input type="checkbox" [checked]="allCustomersSelected()">
            </th>
            <th *ngIf="!customerResultsPresent()" scope="col" class="checkbox-cell" style="cursor: default">
              <input type="checkbox" disabled style="cursor: default">
            </th>
            <th *ngFor="let col of columns" scope="col">
              <span [ngbTooltip]="isColumnUnavailableDuringSearch(col)
                                    ? 'Data for this column is not loaded while searching customers by text. Clear the search to see it.'
                                    : (ExportColumns.COLUMN_HELP_TEXT[col] || (col.length > 24 ? col : null))"
                    [class.text-muted]="isColumnUnavailableDuringSearch(col)"
                    [class.font-italic]="isColumnUnavailableDuringSearch(col)"
                    class="text-truncate d-inline-block"
                    style="max-width: 14rem; vertical-align: bottom;">
                {{ ReportColumns.COLUMN_HEADER_OVERRIDES[col] || col }}
              </span>
            </th>
            <th scope="col" class="text-nowrap sticky-column-right"></th>
          </tr>
          </thead>

          <tbody *ngIf="customerResultsPresent()">
          <ng-template #customCell let-customer="row" let-col="col">
            <ng-container [ngSwitch]="col">
              <ng-container *ngSwitchCase="ReportColumns.COLUMN_NAME_FIRST_NAME">
                <span *ngIf="customer.first_name">{{ customer.first_name }}</span>
                <span *ngIf="!customer.first_name" class="text-secondary">None</span>
                <span *ngIf="customer.preferred_name && (customer.preferred_name != customer.first_name)">
                  "{{ customer.preferred_name }}"
                </span>
              </ng-container>
              <ng-container *ngSwitchCase="ReportColumns.COLUMN_NAME_LAST_NAME">
                <span *ngIf="customer.last_name">{{ customer.last_name }}</span>
                <span *ngIf="!customer.last_name" class="text-secondary">None</span>
              </ng-container>
            </ng-container>
          </ng-template>
          <tr *ngFor="let customer of customerList.results">
            <td (click)="toggleCustomerSelection(customer)" class="checkbox-cell">
              <input type="checkbox"
                     [checked]="selectedCustomerIds.indexOf(customer.id) >= 0">
            </td>
            <td *ngFor="let col of columns"
                routerLink="/customers/{{ customer.id }}"
                class="cursor-pointer">
              <app-report-cell [column]="col"
                               [row]="customer"
                               [getContentItem]="ExportColumns.getContentItem"
                               [customColumns]="ColumnsWithCustomHTML"
                               [objectIDColumns]="ObjectIDColumns"
                               [currencyColumns]="CurrencyColumns"
                               [dateColumns]="DateColumns"
                               [customTemplate]="customCell"></app-report-cell>
            </td>
            <td class="table-button-cell text-nowrap sticky-column-right">
              <a routerLink="/customers/{{ customer.id }}"
               class="btn btn-outline-primary btn-sm mr-1">
                Open
              </a>
            </td>
          </tr>
          </tbody>

          <tbody *ngIf="!customerResultsPresent()">
          <tr>
            <td colspan="99">
              {{ loadingCustomers ? 'Loading...' : 'No customers' }}
            </td>
          </tr>
          </tbody>

        </table>
      </div>

      <div class="alert alert-info" *ngIf="hasLastActivityAfterXFilter()">
        Only recently-active customers are being shown.
        <a href="#" (click)="$event.preventDefault(); handleExpandSearch();">
          Expand search to all customers.
        </a>
      </div>

      <div class="row">
        <div class="col-sm mb-2">
          <label for="resultsPerPage" class="pr-1 align-middle">
            Results per page:
          </label>
          <select id="resultsPerPage" class="form-control d-inline-block" style="width:80px;"
                  [(ngModel)]="pageSizeCustomers" (change)="setPage(1)">
            <option [ngValue]="10">10</option>
            <option [ngValue]="25">25</option>
            <option [ngValue]="50">50</option>
            <option [ngValue]="100">100</option>
          </select>
        </div>
        <div class="col-sm" *ngIf="customerList">
          <nav aria-label="Customer pagination">
            <ul class="pagination justify-content-end">
              <li class="page-item" [class.disabled]="pageNumber <= 1">
                <button class="page-link" aria-label="Previous" [disabled]="pageNumber <= 1"
                   (click)="setPage(pageNumber - 1)">
                  <span aria-hidden="true">&laquo;</span>
                </button>
              </li>
              <li class="page-item" *ngIf="pageNumber > 2">
                <button class="page-link" (click)="setPage(pageNumber - 2)">
                  {{ pageNumber - 2 }}
                </button>
              </li>
              <li class="page-item" *ngIf="pageNumber > 1">
                <button class="page-link" (click)="setPage(pageNumber - 1)">
                  {{ pageNumber - 1 }}
                </button>
              </li>
              <li class="page-item active" aria-current="page">
                <button class="page-link" disabled>
                  {{ pageNumber }}
                  <span class="sr-only">(current)</span>
                </button>
              </li>
              <li class="page-item" *ngIf="pageNumber < lastPageNumber()">
                <button class="page-link" (click)="setPage(pageNumber + 1)">
                  {{ pageNumber + 1 }}
                </button>
              </li>
              <li class="page-item" *ngIf="pageNumber < (lastPageNumber() - 1)">
                <button class="page-link" (click)="setPage(pageNumber + 2)">
                  {{ pageNumber + 2 }}
                </button>
              </li>
              <li class="page-item" [class.disabled]="pageNumber >= lastPageNumber()">
                <button class="page-link" aria-label="Next" [disabled]="pageNumber >= lastPageNumber()"
                   (click)="setPage(pageNumber + 1)">
                  <span aria-hidden="true">&raquo;</span>
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>

  <div class="floating-alert-container">
    <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessage">
      {{ successMessage }}
      <button type="button" class="close" (click)="successMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
      <button type="button" class="close" (click)="errorMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>

</div>
